<template>
  <div
    class="filter-container"
    :class="allFiltersShow ? 'filter-container-open' : ''"
  >
    <form
      class="filter-list"
      :class="allFiltersShow ? `filter-list--open` : ``"
      @submit="onFiltersSubmit"
    >
      <div
        class="filter-item filter-item-title"
        :class="allFiltersShow ? `filter-item-title--open` : ``"
      >
        <span class="modal-filter-title">Расширенный поиск</span>
        <button
          type="button"
          class="modal-close-button"
          @click="this.onFilterModalCloseClick()"
        >
          <span class="visually-hidden">Закрыть</span>
        </button>
      </div>
      <!-- поиск -->
      <div class="filter-item filter-item-search">
        <label class="search-form-label">Поиск</label>
        <div class="form-field-cover">
          <input
            type="text"
            class="form-field"
            placeholder="Поиск"
            v-model="this.localFilters.anyvalue"
            @input="onChangeAnyValue"
          />
          <img
            v-if="this.localFilters.anyvalue.length > 0"
            src="@/assets/img/icons/clear_filter.svg"
            alt=""
            class="cancel-filter-img"
            :width="this.imgWidth"
            :height="this.imgHeight"
            @click="onFilterClearClick('anyvalue', $event)"
          />
          <img
            src="@/assets/img/icons/filter-search.svg"
            alt=""
            class="cancel-filter-img"
            :width="this.imgWidth"
            :height="this.imgHeight"
          />
        </div>
      </div>
      <!-- статусы -->
      <div
        class="filter-item filter-item-status filter-item-desktop"
        :class="allFiltersShow ? `filter-item-desktop--open` : ``"
      >
        <label class="search-form-label">Статус</label>
        <div
          class="form-field-cover"
          @click="this.showStatusFilter = !this.showStatusFilter"
        >
          <div class="form-field">
            {{
              this.localFilters.statuses.length > 0
                ? this.localFilters.statuses.slice(0, 2).join(", ")
                : "Статус"
            }}
          </div>

          <img
            v-if="this.localFilters.statuses.length > 0"
            src="@/assets/img/icons/clear_filter.svg"
            alt=""
            class="cancel-filter-img"
            :width="this.imgWidth"
            :height="this.imgHeight"
            @click="onFilterClearClick('statuses', $event)"
          />
          <img
            src="@/assets/img/icons/arrow-down.svg"
            alt=""
            class="cancel-filter-img"
            :width="this.imgWidth"
            :height="this.imgHeight"
          />
        </div>
        <div class="field__content" v-if="this.showStatusFilter">
          <span class="modal__title">Статус ЭД</span>
          <div class="modal-filter">
            <div class="modal-filter__items">
              <label
                v-for="(st, index) in this.listStatuses"
                :key="index"
                class="modal-filter__lbl"
              >
                <input
                  type="checkbox"
                  :value="st"
                  hidden
                  :checked="this.localFilters.statuses.indexOf(st) !== -1"
                  @click="onStatusClick"
                />
                <span></span>
                {{ st }}
              </label>
            </div>
          </div>
          <div class="modal__btns" @click="this.showStatusFilter = false">
            <button
              class="modal__show blue-btn"
              type="button"
              @click="onStatusSubmit"
            >
              Применить
            </button>
          </div>
        </div>
      </div>
      <!-- процедура -->
      <div
        class="filter-item filter-item-proc filter-item-desktop"
        :class="allFiltersShow ? `filter-item-desktop--open` : ``"
      >
        <label class="search-form-label">Таможенная процедура</label>
        <div
          class="form-field-cover"
          @click="this.showProcedureFilter = !this.showProcedureFilter"
        >
          <div class="form-field">
            {{
              this.localFilters.procedures.length > 0
                ? this.localFilters.procedures.slice(0, 3).join(", ")
                : "Таможенная процедура"
            }}
          </div>
          <img
            v-if="this.localFilters.procedures.length > 0"
            src="@/assets/img/icons/clear_filter.svg"
            alt=""
            class="cancel-filter-img"
            :width="this.imgWidth"
            :height="this.imgHeight"
            @click="onFilterClearClick('procedures', $event)"
          />
          <img
            src="@/assets/img/icons/arrow-down.svg"
            alt=""
            class="cancel-filter-img"
            :width="this.imgWidth"
            :height="this.imgHeight"
          />
        </div>
        <div class="field__content" v-if="this.showProcedureFilter">
          <span class="modal__title">Процедура</span>
          <div class="modal-filter">
            <div class="modal-filter__items">
              <label
                v-for="(pr, index) in this.listProcedures"
                :key="index"
                class="modal-filter__lbl"
              >
                <input
                  type="checkbox"
                  :value="pr"
                  hidden
                  :checked="this.localFilters.procedures.indexOf(pr) !== -1"
                  @click="onProcedureClick"
                />
                <span></span>
                {{ pr }}
              </label>
            </div>
          </div>
          <div class="modal__btns" @click="this.showProcedureFilter = false">
            <button
              class="modal__show blue-btn"
              type="button"
              @click="onProcedureSubmit"
            >
              Применить
            </button>
          </div>
        </div>
      </div>
      <!-- количество дней -->
      <div
        class="filter-item filter-item-days filter-item-desktop"
        :class="allFiltersShow ? `filter-item-desktop--open` : ``"
      >
        <label class="search-form-label">Период (дней)</label>
        <div class="field-date">
          <button
            type="button"
            class="btn-min-max btn-min"
            @click="onPerChange(this.globalFilters.period - 1)"
          >
            <img src="@/assets/img/icons/btn-minus.svg" />
          </button>
          <div class="form-field-cover form-field-days">
            <input
              type="number"
              class="form-field form-field--days"
              v-model="this.globalFilters.period"
              @input="onPerChange()"
              placeholder="Кол-во дней"
            />
            <!-- @input="onPerInput($event.target.value)" -->
          </div>
          <button
            type="button"
            class="btn-min-max btn-max"
            @click="onPerChange(this.globalFilters.period + 1)"
          >
            <img src="@/assets/img/icons/btn-plus.svg" />
          </button>
        </div>
      </div>

      <div
        class="filter-item filter-item-button"
        :class="allFiltersShow ? `filter-item-button--disable` : ``"
        @click="allFiltersShow = !allFiltersShow"
      >
        <div class="filter-button-wrapper">
          <div class="filter-button-first">
            <img
              class="button-img button-img--filter"
              src="@/assets/img/icons/filter.svg"
              alt=""
              :width="this.imgWidth"
              :height="this.imgHeight"
            />
            <span class="filter-button-label">Фильтры</span>
          </div>
          <span class="filter-count" v-if="this.activeFiltersCount != 0">
            {{ this.activeFiltersCount }}
          </span>
          <div class="filter-button-third">
            <img
              v-if="
                this.activeFiltersCount != 0 && !this.showMobileActiveFilters
              "
              class="button-img button-img--chevron"
              src="@/assets/img/icons/chevron-white-down.svg"
              alt=""
              :width="this.imgWidth"
              :height="this.imgHeight"
              @click="
                $event.stopPropagation();
                this.showMobileActiveFilters = true;
              "
            />
            <img
              v-if="
                this.activeFiltersCount != 0 && this.showMobileActiveFilters
              "
              class="button-img button-img--chevron"
              src="@/assets/img/icons/chevron-white-up.svg"
              alt=""
              :width="this.imgWidth"
              :height="this.imgHeight"
              @click="
                $event.stopPropagation();
                this.showMobileActiveFilters = false;
              "
            />
          </div>
        </div>
      </div>
      <!-- Транспортное средство -->
      <div
        class="filter-item filter-item-transp filter-item-all"
        :class="allFiltersShow ? `filter-item-all--open` : ``"
      >
        <label class="search-form-label" for="search-transp"
          >Транспортное средство</label
        >
        <div class="form-field-cover">
          <input
            class="form-field"
            type="text"
            id="search-transp"
            placeholder="Транспортное средство"
            v-model="this.globalFilters.numTransp"
          />
          <img
            v-if="this.globalFilters.numTransp.length > 0"
            src="@/assets/img/icons/clear_filter.svg"
            alt=""
            class="cancel-filter-img"
            :width="this.imgWidth"
            :height="this.imgHeight"
            @click="this.globalFilters.numTransp = ''"
          />
        </div>
      </div>
      <!-- Номер контейнера -->
      <div
        class="filter-item filter-item-cont filter-item-all"
        :class="allFiltersShow ? `filter-item-all--open` : ``"
      >
        <label class="search-form-label" for="search-numcont"
          >Номер контейнера</label
        >
        <div class="form-field-cover">
          <input
            class="form-field"
            type="text"
            id="search-numcont"
            placeholder="Номер контейнера"
            v-model="this.globalFilters.numCont"
          />
          <img
            v-if="this.globalFilters.numCont.length > 0"
            src="@/assets/img/icons/clear_filter.svg"
            alt=""
            class="cancel-filter-img"
            :width="this.imgWidth"
            :height="this.imgHeight"
            @click="this.globalFilters.numCont = ''"
          />
        </div>
      </div>
      <!-- Поиск по комментарию -->
      <div
        class="filter-item filter-item-comm filter-item-all"
        :class="allFiltersShow ? `filter-item-all--open` : ``"
      >
        <label class="search-form-label" for="search-comment"
          >Поиск по комментарию</label
        >
        <div class="form-field-cover">
          <input
            class="form-field"
            type="text"
            id="search-comment"
            placeholder="Поиск по комментарию"
            v-model="this.globalFilters.comment"
          />
          <img
            v-if="this.globalFilters.comment.length > 0"
            src="@/assets/img/icons/clear_filter.svg"
            alt=""
            class="cancel-filter-img"
            :width="this.imgWidth"
            :height="this.imgHeight"
            @click="this.globalFilters.comment = ''"
          />
        </div>
      </div>
      <!-- Декларант -->
      <div
        class="filter-item filter-item-decl filter-item-all"
        :class="allFiltersShow ? `filter-item-all--open` : ``"
      >
        <label class="search-form-label" for="search-status"
          >Лицо, оформившее ДТ (гр. 54)</label
        >
        <div class="form-field-cover">
          <input
            class="form-field"
            type="text"
            id="search-status"
            placeholder="Лицо, оформившее ДТ (гр. 54)"
            v-model="this.globalFilters.declarant"
          />
          <img
            v-if="this.globalFilters.declarant.length > 0"
            src="@/assets/img/icons/clear_filter.svg"
            alt=""
            class="cancel-filter-img"
            :width="this.imgWidth"
            :height="this.imgHeight"
            @click="this.globalFilters.declarant = ''"
          />
        </div>
      </div>
      <!-- Основное описание -->
      <div
        class="filter-item filter-item-descr filter-item-all"
        :class="allFiltersShow ? `filter-item-all--open` : ``"
      >
        <label class="search-form-label" for="search-status"
          >Основное описание (31.1 графа)</label
        >
        <div class="form-field-cover">
          <input
            class="form-field"
            type="text"
            id="search-status"
            placeholder="Основное описание (31.1 графа)"
            v-model="this.globalFilters.goodDesc"
          />
          <img
            v-if="this.globalFilters.goodDesc.length > 0"
            src="@/assets/img/icons/clear_filter.svg"
            alt=""
            class="cancel-filter-img"
            :width="this.imgWidth"
            :height="this.imgHeight"
            @click="this.globalFilters.goodDesc = ''"
          />
        </div>
      </div>
      <!-- Артикул -->
      <div
        class="filter-item filter-item-sku filter-item-all"
        :class="allFiltersShow ? `filter-item-all--open` : ``"
      >
        <label class="search-form-label" for="search-status">Артикул</label>
        <div class="form-field-cover">
          <input
            class="form-field"
            type="text"
            id="search-status"
            placeholder="Артикул"
            v-model="this.globalFilters.articul"
          />
          <img
            v-if="this.globalFilters.articul.length > 0"
            src="@/assets/img/icons/clear_filter.svg"
            alt=""
            class="cancel-filter-img"
            :width="this.imgWidth"
            :height="this.imgHeight"
            @click="this.globalFilters.articul = ''"
          />
        </div>
      </div>
      <!-- Документ -->
      <div
        class="filter-item filter-item-doc filter-item-all filter-item-last"
        :class="allFiltersShow ? `filter-item-all--open` : ``"
      >
        <label class="search-form-label" for="search-status">Документ</label>

        <div class="form-field-cover">
          <select id="type-docs" v-model="this.globalFilters.typeDoc">
            <option value="">Любой</option>
            <option value="02">CMR</option>
            <option value="03">Контракт</option>
            <option value="04">Инвойс</option>
          </select>

          <input
            class="form-field form-field-numdoc"
            type="text"
            id="search-status"
            placeholder="Номер"
            v-model="this.globalFilters.numDoc"
          />
          <img
            v-if="this.globalFilters.numDoc.length > 0"
            src="@/assets/img/icons/clear_filter.svg"
            alt=""
            class="cancel-filter-img"
            :width="this.imgWidth"
            :height="this.imgHeight"
            @click="
              this.globalFilters.numDoc = '';
              this.globalFilters.typeDoc = '';
            "
          />
        </div>
      </div>

      <div
        class="filter-item filter-item-buttons button-modal filter-item-all"
        :class="
          allFiltersShow ? `filter-item-all--open button-modal--open` : ``
        "
      >
        <button
          type="button"
          class="search-form-button"
          @click="this.onFilterModalCloseClick()"
        >
          Отмена
        </button>
        <button
          class="search-form-button search-form-button-done"
          type="submit"
          @click="allFiltersShow = !allFiltersShow"
        >
          Применить
        </button>
      </div>
    </form>
    <!-- Блок с выбранными фильтрами -->
    <ul
      class="filters-on"
      :class="showMobileActiveFilters ? `filters-on--mobile-active` : ``"
      v-if="
        !allFiltersShow &&
        (this.activeFiltersCount != 0 || user?.inn_list?.join().length > 0)
      "
    >
      <li
        v-if="user?.inn_list?.join().length > 0"
        class="filters-on-item"
        @click="this.showUserINNList = !this.showUserINNList"
      >
        <span class="btn-menu btn-menu-inn">ИНН</span>
        <img
          src="@/assets/img/icons/warning.svg"
          alt=""
          class="cancel-filter-img cancel-filter-img--close"
          :width="this.imgWidth"
          :height="this.imgHeight"
          
        />
        <!-- показ списка ИНН -->
        <section v-if="this.showUserINNList" class="modal-orgs">
          <form class="modal-orgs-content">
            <h2 class="modal-org-header modal-org-header-inn">
              Доступные организации
            </h2>
            <div class="modal-orgs-header">
              <span class="org-header-name org-header-name-full">Название</span>
              <span class="org-header-inn">ИНН</span>
            </div>
            <ul class="org-list">
              <li
                class="org-item"
                v-for="(inn, key) in this.user?.inn_list"
                :key="key"
              >
                <!-- Сюда надо передавать еще и название организации! -->
                <span class="org-item-name">{{ declarant }}</span>
                <span class="org-item-inn">{{ inn }}</span>
              </li>
            </ul>
            <div class="modal-org-btn-ok">
              <button class="blue-border-btn">Ок</button>
            </div>
          </form>
        </section>
      </li>
      <li
        class="filters-on-item filters-on-item--close"
        v-if="this.activeFiltersCount > 1"
      >
        Сбросить все
        <img
          src="@/assets/img/icons/close-filter-all.svg"
          alt=""
          class="cancel-filter-img cancel-filter-img--close"
          :width="this.imgWidth"
          :height="this.imgHeight"
          @click="this.clearAllFilters($event)"
        />
      </li>
      <li
        v-for="(item, index) in this.activeFilters.localFilters"
        :key="index"
        class="filters-on-item"
      >
        {{
          typeof item[1] == "object"
            ? filtersDescr[item[0]] + (item[1].length > 1 ? "ы" : "")
            : item[1]
        }}
        <!-- {{ filtersDescr[item[0]] }} -->
        <img
          src="@/assets/img/icons/close-filter.svg"
          alt=""
          class="cancel-filter-img"
          :width="this.imgWidth"
          :height="this.imgHeight"
          @click="onFilterClearClick(item[0], $event)"
        />
      </li>

      <li
        v-for="(item, index) in this.activeFilters.globalFilters"
        :key="index"
        class="filters-on-item"
      >
        {{ item[1] }}
        <!-- {{ filtersDescr[item[0]] }} -->
        <img
          src="@/assets/img/icons/close-filter.svg"
          alt=""
          class="cancel-filter-img"
          :width="this.imgWidth"
          :height="this.imgHeight"
          @click="
            this.globalFilters[item[0]] = '';
            onFiltersSubmit($event);
          "
        />
      </li>
      <!-- <li 
        class="filters-on-item filters-on-item--close"
        v-if="this.activeFiltersCount  > 1"
      >
        Сбросить все фильтры
        <img
            src="@/assets/img/icons/close-filter-all.svg"
            alt=""
            class="cancel-filter-img cancel-filter-img--close"
            :width="this.imgWidth"
            :height="this.imgHeight"
            @click=" this.clearAllFilters($event) "
          /> 
      </li> -->
    </ul>
  </div>
  <div
    v-if="
      this.showStatusFilter || this.showProcedureFilter || this.allFiltersShow
    "
    class="list-dt-outside"
    @click="this.onOutsideClick()"
  ></div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  LOCAL_FILTERS_DEFAULT,
  GLOBAL_FILTERS_DEFAULT,
} from "@/common/const.js";

export default {
  name: "ListDTFilter",
  data() {
    return {
      imgHeight: 18,
      imgWidth: 18,
      showStatusFilter: false,
      showProcedureFilter: false,
      showUserINNList: false,
      delayTimer: null,
      allFiltersShow: false,
      showMobileActiveFilters: false,
      activeFilters: {
        globalFilters: {},
        localFilters: {},
      },
      activeFiltersCount: 0,
      globalFiltersDefault: { ...GLOBAL_FILTERS_DEFAULT },
      localFiltersDefault: { ...LOCAL_FILTERS_DEFAULT },
      globalFilters: {
        numTransp: "",
        numCont: "",
        comment: "",
        declarant: "",
        articul: "",
        groupDesc: "",
        goodDesc: "",
        period: 10,
        tnved: "",
        typeDoc: "",
        numDoc: "",
      },
      localFilters: {
        anyvalue: "",
        statuses: [],
        procedures: [],
      },
      filtersDescr: {
        anyvalue: "Поиск",
        statuses: "Статус",
        procedures: "Процедура",
        numTransp: "ТС",
        numCont: "Номер контейнера",
        comment: "Комментарий",
        declarant: "Декларант",
        articul: "Артикул",
        groupDesc: "Описание группы",
        goodDesc: "Описание товара",
        tnved: "ТНВЭД",
        typeDoc: "Тип документа",
        numDoc: "Номер документа",
      },
    };
  },
  computed: {
    ...mapState("ListDT", [
      "listStatuses",
      "listProcedures",
      "lcFilters",
      "glFilters",
    ]),
    ...mapState("Auth", ["user"]),
    showStFilter() {
      return this.showStatusFilter === true ? "" : "hidden";
    },
  },
  // watch: {
  //   'globalFilters.period': {
  //     handler(newValue, oldValue) {
  //       clearTimeout(this.delayTimer);
  //       this.delayTimer = setTimeout(async () => {

  //         if (oldValue == newValue)
  //           return;

  //         let v = parseInt(newValue);
  //         if (isNaN(v) || v <= 0) this.globalFilters.period = 1;

  //         await this.changeGlFilters(this.globalFilters);
  //       }, 700);
  //     },
  //     deep: true
  //   }
  // },
  methods: {
    ...mapActions("ListDT", [
      "filterData",
      "changeGlFilters",
      "changeLcFilters",
      "changeCurrentPage",
    ]),
    onChange(event) {
      console.log(event.target.value);
    },
    onPerChange(newValue = this.globalFilters.period) {
      this.globalFilters.period = newValue;

      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(async () => {
        let v = parseInt(newValue);
        if (isNaN(v) || v <= 0) this.globalFilters.period = 1;

        if (!this.allFiltersShow) this.changeGlFilters(this.globalFilters);
      }, 700);
    },

    // onChangeRegNo(event) {
    //   const payload = {
    //     'name': 'regno',
    //     'value': event.target.value,
    //     'reset': event.target.value.length === 0
    //   }
    //   this.filterData(payload);
    // },
    onChangeAnyValue() {
      if (this.allFiltersShow) return;
      clearTimeout(this.delayTimer);
      const payload = {
        name: "anyvalue",
        value: this.localFilters.anyvalue,
        reset: this.localFilters.anyvalue.length === 0,
      };

      this.delayTimer = setTimeout(async () => {
        this.filterData(payload);
        this.localFilters = { ...this.lcFilters };
      }, 700);
      this.refreshActiveFilters();
    },
    onStatusClick(event) {
      const v = event.target.value;
      if (this.localFilters.statuses == "") this.localFilters.statuses = [];

      const i = this.localFilters.statuses.indexOf(v);

      if (event.target.checked && i === -1) {
        this.localFilters.statuses.push(v);
        return;
      }
      if (!event.target.checked && i >= 0) {
        this.localFilters.statuses.splice(i, 1);
      }
    },
    onStatusSubmit() {
      if (this.allFiltersShow) return;
      const payload = {
        name: "statuses",
        value: [...this.localFilters.statuses],
        reset: this.localFilters.statuses.length === 0,
      };
      this.filterData(payload);
      this.refreshActiveFilters();
    },
    onProcedureClick(event) {
      if (this.localFilters.procedures == "") this.localFilters.procedures = [];

      const v = event.target.value;
      const i = this.localFilters.procedures.indexOf(v);
      if (event.target.checked && i === -1) {
        this.localFilters.procedures.push(v);
        return;
      }
      if (!event.target.checked && i >= 0) {
        this.localFilters.procedures.splice(i, 1);
      }
    },
    onProcedureSubmit() {
      if (this.allFiltersShow) return;
      const payload = {
        name: "procedures",
        value: [...this.localFilters.procedures],
        reset: this.localFilters.procedures.length === 0,
      };
      this.filterData(payload);
      this.refreshActiveFilters();
    },
    onFilterClearClick(paramName, event) {
      event.stopPropagation();

      const payload = {
        name: paramName,
        reset: true,
      };
      this.filterData(payload);

      switch (paramName) {
        case "anyvalue":
          this.localFilters.anyvalue = "";
          break;
        case "statuses":
          this.localFilters.statuses = [];
          break;
        case "procedures":
          this.localFilters.procedures = [];
          break;
      }
      this.refreshActiveFilters();
    },

    onFiltersSubmit(event) {
      event.preventDefault();
      this.changeLcFilters(this.localFilters);
      this.changeGlFilters(this.globalFilters);
      this.onFilterModalCloseClick();
    },

    clearAllFilters(event) {
      // период не трогаем при сбросе
      let per = this.globalFilters.period;

      this.localFilters = { ...LOCAL_FILTERS_DEFAULT };
      this.globalFilters = { ...GLOBAL_FILTERS_DEFAULT };
      this.globalFilters.period = per;
      this.onFiltersSubmit(event);
    },

    onFilterModalCloseClick() {
      this.refreshPageFilterDataByStore();
      this.showStatusFilter = false;
      this.showProcedureFilter = false;
      this.allFiltersShow = false;
    },

    onOutsideClick() {
      this.onFilterModalCloseClick();
    },
    refreshPageFilterDataByStore() {
      this.globalFilters = { ...this.glFilters };
      this.localFilters = { ...this.lcFilters };
      this.refreshActiveFilters();
    },
    refreshActiveFilters() {
      this.activeFilters.globalFilters = Object.entries(
        this.globalFilters
      ).filter((item) => this.filtersDescr[item[0]] && item[1].length != 0);
      this.activeFilters.localFilters = Object.entries(
        this.localFilters
      ).filter((item) => this.filtersDescr[item[0]] && item[1].length != 0);
      this.activeFiltersCount =
        this.activeFilters.localFilters.length +
        this.activeFilters.globalFilters.length;
    },
  },
  mounted() {
    this.refreshPageFilterDataByStore();
  },
};
</script>

<style lang="scss">
.list-dt-outside {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 1;
}
</style>
